import { computed, onBeforeMount, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { AccessLevel } from '../services/api/shareDashboard/types';

import { DashboardStore } from '../stores/dashboard';

export function useDashboardRouteSync(dashboard: DashboardStore) {
    const route = useRoute();
    const router = useRouter();

    const isDashboardOwner = computed(() => {
        return dashboard.selectedDashboard?.accessLevel === AccessLevel.Owner;
    });

    const updateRouteId = async (id: string) => {
        await router.replace({
            query: { ...route.query, id },
        });
    };
    const openWidgetForm = async (id: string = 'new') => {
        if (!isDashboardOwner.value) return;
        await router.replace({
            query: { ...route.query, widgetForm: id },
        });
    };

    const closeWidgetForm = () => {
        const query = { ...route.query };
        delete query.widgetForm;
        router.replace({
            query,
        });
    };

    onBeforeMount(async () => {
        await dashboard.getItems();
        const dashboardId = route.query?.id?.toString();
        const match = dashboard.items.some((e) => e.id === dashboardId);
        const targetId = match ? dashboardId : dashboard.items[0]?.id;

        if (targetId) {
            await updateRouteId(targetId);
        }
    });

    onMounted(async () => {
        if (route.query.widgetForm === 'new') {
            closeWidgetForm();
            return;
        }
        if (route.query.widgetForm && isDashboardOwner.value) {
            dashboard.widgetFormOpen = route.query.widgetForm.toString();
        }
    });

    watch(
        () => route.query.id,
        async (queryId, oldQueryId) => {
            try {
                if (queryId && queryId !== oldQueryId) {
                    await dashboard.getItem(queryId.toString());
                } else if (!queryId && dashboard.items.length > 0) {
                    await updateRouteId(dashboard.items[0]?.id);
                }
            } catch (error) {
                console.log(error);
            }
        },
        { immediate: true }
    );

    watch(
        () => route.query.widgetForm,
        (newWidgetForm) => {
            if (!newWidgetForm) {
                dashboard.widgetFormOpen = undefined;
                return;
            }

            if (!isDashboardOwner.value) {
                dashboard.widgetFormOpen = undefined;
                closeWidgetForm();
                return;
            }

            dashboard.widgetFormOpen = newWidgetForm.toString();
        }
    );
    return {
        openWidgetForm,
        closeWidgetForm,
    };
}
